import { render, staticRenderFns } from "./item-filters-panel.vue?vue&type=template&id=711d852f&"
import script from "./item-filters-panel.vue?vue&type=script&lang=ts&"
export * from "./item-filters-panel.vue?vue&type=script&lang=ts&"
import style0 from "./item-filters-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports